var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-18.8%",
    y: "-18.8%",
    width: "137.5%",
    height: "137.5%",
    filterUnits: "objectBoundingBox",
    id: "03qd05hewa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0705882353 0 0 0 0 0.0705882353 0 0 0 0 0.0705882353 0 0 0 0.3 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "gorqx89w8b",
    cx: 24,
    cy: 24,
    r: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#03qd05hewa)",
    xlinkHref: "#gorqx89w8b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E20074",
    xlinkHref: "#gorqx89w8b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 23v-8h-2v8h-8v2h8v8h2v-8h8v-2z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E20074",
    cx: 24,
    cy: 24,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.837 27.75a8.153 8.153 0 0 0 1.913-5.25 8.25 8.25 0 1 0-8.25 8.25c1.92 0 3.78-.676 5.25-1.913l5.692 5.663 1.058-1.058-5.663-5.692zm-6.337 1.5a6.75 6.75 0 1 1 0-13.5 6.75 6.75 0 0 1 0 13.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.d18b5d4b85b1f45ba6104bd76f47aa58.svg";
export { ForwardRef as ReactComponent };